var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletinBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "class",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.029,
    height: 48.98,
    viewBox: "0 0 52.029 48.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M50.5,38.067V19.573h1.524V15H7.621v1.524H50.5v1.524H1.524V16.524H6.1V15H0v4.573H1.524v27.64h3.15v4.126l1.714,1.714L1.626,55.094v7.362H0V63.98H52.029V62.456H50.4V55.094L45.64,53.053l1.714-1.714V47.213H50.5V39.592H48.98v6.1H47.354v-.762a2.289,2.289,0,0,0-2.286-2.286H40.495a2.289,2.289,0,0,0-2.286,2.286v.762H30.587v-.762A2.289,2.289,0,0,0,28.3,42.64H23.728a2.289,2.289,0,0,0-2.286,2.286v.762H13.82v-.762a2.289,2.289,0,0,0-2.286-2.286H6.961a2.289,2.289,0,0,0-2.286,2.286v.762H3.049V19.573H48.98V38.067ZM3.15,56.1,7.88,54.072h2.736L15.344,56.1v6.357H3.15Zm21.5-2.027h2.736L32.111,56.1v6.357H19.917V56.1Zm24.232,8.383H36.684V56.1l4.729-2.027h2.736L48.878,56.1ZM39.733,44.927a.763.763,0,0,1,.762-.762h4.573a.763.763,0,0,1,.762.762v5.781l-1.84,1.84H41.573l-1.84-1.84Zm-1.524,2.286v4.126l1.714,1.714L35.16,55.094v7.362H33.636V55.094l-4.762-2.041,1.714-1.714V47.213ZM22.966,44.927a.763.763,0,0,1,.762-.762H28.3a.763.763,0,0,1,.762.762v5.781l-1.84,1.84H24.806l-1.84-1.84Zm-1.524,2.286v4.126l1.714,1.714-4.762,2.041v7.362H16.869V55.094l-4.762-2.041,1.714-1.714V47.213ZM6.2,44.927a.763.763,0,0,1,.762-.762h4.573a.763.763,0,0,1,.762.762v5.781l-1.84,1.84H8.039L6.2,50.708Z",
    transform: "translate(0 -15)",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M85,120.165a3.046,3.046,0,0,0,5.276,2.079l4.28.8a3.3,3.3,0,1,0,3.7-3.866L95.246,114.1a2.795,2.795,0,1,0-4.787-.254l-2.581,3.272A3.052,3.052,0,0,0,85,120.165Zm3.049,1.524a1.524,1.524,0,1,1,1.524-1.524A1.526,1.526,0,0,1,88.051,121.689Zm6.59-.178-3.616-.678a3.044,3.044,0,0,0-1.5-3.336l2-2.538a2.785,2.785,0,0,0,2.537.138l2.54,4.28A3.318,3.318,0,0,0,94.64,121.511Zm4.944.94a1.778,1.778,0,1,1-1.778-1.778A1.78,1.78,0,0,1,99.584,122.451Zm-6.656-11.178a1.27,1.27,0,1,1-1.27,1.27A1.272,1.272,0,0,1,92.928,111.273Z",
    transform: "translate(-76.364 -100.121)",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M277,136h9.908v1.524H277Z",
    transform: "translate(-248.851 -123.705)",
    fill: "#494949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M307,196h9.908v1.524H307Z",
    transform: "translate(-275.802 -177.607)",
    fill: "#494949"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M359.5,166h4.573v1.524H359.5Z",
    transform: "translate(-322.966 -150.656)",
    fill: "#494949"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M277,196h1.524v1.524H277Z",
    transform: "translate(-248.851 -177.607)",
    fill: "#494949"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M277,166h6.859v1.524H277Z",
    transform: "translate(-248.851 -150.656)",
    fill: "#494949"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M389.5,136h1.524v1.524H389.5Z",
    transform: "translate(-349.918 -123.705)",
    fill: "#494949"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M452,105h1.524v4.573H452Z",
    transform: "translate(-406.069 -95.853)",
    fill: "#494949"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M452,75h1.524v1.524H452Z",
    transform: "translate(-406.069 -68.902)",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletinBoard);
export default __webpack_public_path__ + "static/media/bulletinBoard.d3dacbbd.svg";
export { ForwardRef as ReactComponent };